import { useEffect } from 'react';

import toast from '#/components/common/toast';

import { NOTIFICATIONS_MAP } from '#/features/notifications/map';
import { NotificationEntryType } from '#/features/notifications/types';
import {
  useNotificationsActions,
  useNotificationsView,
} from '#/features/notifications/notifications-context';
import toastHistory from '#/features/notifications/toast-history';
import {
  NotificationOptions,
  notificationTopic,
} from '#/features/notifications/topic';

export default function NotificationsListener() {
  const view = useNotificationsView();
  const actions = useNotificationsActions();

  useEffect(() => {
    function handleNotification<T extends NotificationEntryType>(
      options: NotificationOptions[T],
    ) {
      const { kind, props } = options;
      const { getId, Component, toastOptions } =
        NOTIFICATIONS_MAP[options.kind];
      const id = getId(kind, props);
      const wasDisplayedOnce = toastHistory.hasId(id);

      actions.save({ id, kind, props });
      toastHistory.addId(id);

      if (wasDisplayedOnce) return;
      if (view.shouldDisplayToast) {
        toast.base(<Component {...props} />, { toastId: id, ...toastOptions });
      }
    }

    notificationTopic.subscribe(handleNotification);
    return () => {
      notificationTopic.unsubscribe(handleNotification);
    };
  }, [actions, view.shouldDisplayToast]);

  return null;
}
